import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import AppComponent from './app/app';
import BASE from './app/app.base';

console.log('Senet ID:', BASE.version);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
